/**
 * Home Application
 *
 * Uses RootLayoutPublic to render immediately without any session check.
 * Authentication is handled in the background by useBackgroundAuth (in HomePage).
 * Only components that actually need auth subscribe to session state individually,
 * so the whole screen does NOT re-render on auth state changes.
 */

import { RootLayoutPublic } from '@room/shared-ui';
import { HomePage } from './pages/HomePage';
import './App.css';

export function App() {
  return (
    <RootLayoutPublic showNavigation={false} devConsoleOffset={72}>
      <HomePage />
    </RootLayoutPublic>
  );
}
